import React from 'react';
import { Card, Button } from 'react-bootstrap';

const subscriptionPlans = [
    {
        plan: 'Professional',
        price: '$99.00',
        type: 'Monthly',
        paymentMethod: 'M-Pesa',
        activatedDate: 'June 23, 2026',
        expireDate: 'July 23, 2026',
        expired: true,
    },
    {
        plan: 'Enterprise',
        price: '$199.00',
        type: 'Yearly',
        paymentMethod: 'M-Pesa',
        activatedDate: 'January 10, 2026',
        expireDate: 'January 10, 2027',
        expired: false,
    },
];

export default function ProfileSubscriptionComp() {

    return (<>
        <div className='tab-header'>
            <h2>Subscription</h2>
            <p>Personalize your account and update your sign in preferences.</p>
        </div>
        <div className="subscription-plan-main">
            {subscriptionPlans.map((subscriptionPlan) => (
                <Card className="subscription-plan-card" key={subscriptionPlan.plan}>
                    <div className="subscription-plan-row">
                        <div className="plan-field">
                            <span className="field-label">Plan</span>
                            <span className="field-value" title={subscriptionPlan.plan}>{subscriptionPlan.plan}</span>
                        </div>
                        <div className="plan-field">
                            <span className="field-label">Price</span>
                            <span className="field-value" title={subscriptionPlan.price}>{subscriptionPlan.price}</span>
                        </div>
                        <div className="plan-field">
                            <span className="field-label">Type</span>
                            <span className="field-value" title={subscriptionPlan.type}>{subscriptionPlan.type}</span>
                        </div>
                        <div className="plan-field">
                            <span className="field-label">Payment Method</span>
                            <span className="field-value" title={subscriptionPlan.paymentMethod}>{subscriptionPlan.paymentMethod}</span>
                        </div>
                        <div className="plan-field">
                            <span className="field-label">Activated Date</span>
                            <span className="field-value" title={subscriptionPlan.activatedDate}>{subscriptionPlan.activatedDate}</span>
                        </div>
                        <div className="plan-field">
                            <span className="field-label">Expire Date</span>
                            <span
                                className={`field-value${subscriptionPlan.expired ? ' expire' : ''}`}
                                title={subscriptionPlan.expireDate}
                            >
                                {subscriptionPlan.expireDate}
                            </span>
                        </div>
                        <div className="plan-action">
                            <Button
                                className="custom-bttn style-1"
                                disabled={!subscriptionPlan.expired}
                            >
                                Renew Now
                            </Button>
                        </div>
                    </div>
                </Card>
            ))}
        </div>
    </>
    );
}
